<template>
  <BaseItem
      ref="BaseItem"
      :item-uid="itemUid"
      :subtract-height="subtractHeight"
      :parentComponent="parentComponent"
      dto-detail-model="BatchRunDetailQueryDTO"
      dto-save-model="BatchRunSaveCommandDTO"
      dto_validate_model="BatchRunValidateCommandDTO"
      dto-restore-model="BatchRunRestoreCommandDTO"
      dto-filter-restore-model="BatchRunDetailResponseDTO"
      :store-name="store_name"
      :modal-dialog="modalDialog"
      :routeFullScreen="routeFullScreen"
      @resize="onResize"
      @cancel="$emit('cancel')"
      @save="onSave"
      :readonly="readonly"
      :dialog="dialog"
      :metadata="metadata"
  >
    <template v-slot:body="{editedItem, lockPage, instance, slotHeight, editedItemCommon}">
      <v-sheet>
        <v-container fluid>
          <v-row no-gutters dense>
            <BaseCardListBlock :title="$t('common')">
              <template v-slot:left>
                <BatchRunStatus v-model="editedItem.status" large></BatchRunStatus>
              </template>
              <template>
                <v-row dense no-gutters class="flex nowrap px-3">
                  <v-col class="d-flex justify-end"><span class="text-h6">{{editedItem.title}}</span></v-col>
                  <v-col class="d-flex justify-end ml-3" cols="1"></v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row v-if="!!editedItem.delivery_date" dense no-gutters class="flex nowrap px-3">
                  <v-col class="d-flex justify-end"><span class="text-h6">{{$t('columns.delivery')}}</span></v-col>
                  <v-col class="d-flex justify-end ml-3"><span class="text-h6">{{editedItem.delivery_date}}</span></v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row dense no-gutters class="flex nowrap px-3">
                  <v-col class="d-flex justify-end"><span class="text-h6">{{$t('columns.qty')}}</span></v-col>
                  <v-col class="d-flex justify-end ml-3"><span class="text-h6">{{editedItem.quantity}}</span></v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row v-if="!!editedItem.sn_from" dense no-gutters class="flex nowrap px-3">
                  <v-col class="d-flex justify-end"><span class="text-h6">{{$t('columns.sn')}}</span></v-col>
                  <v-col class="d-flex justify-end ml-3"><span class="text-h6">{{editedItem.sn_from}}-{{editedItem.sn_to}}</span></v-col>
                </v-row>
              </template>
            </BaseCardListBlock>
            <v-spacer></v-spacer>
            <BaseCardListBlock title="SMD" v-if="editedItem.lot_size_smd > 0" class="mr-6">
              <template v-slot:left>
                <BatchRunStatus v-model="editedItem.status" large></BatchRunStatus>
              </template>
              <template>
                <v-row dense no-gutters class="flex nowrap px-3">
                  <v-col class="d-flex justify-center mx-5"><span class="text-h6">{{$t('columns.qty')}}</span></v-col>
                  <v-col class="d-flex justify-end"><span class="text-h6">{{editedItem.lot_size_smd}}</span></v-col>
                </v-row>
              </template>
            </BaseCardListBlock>
            <BaseCardListBlock title="THT" v-if="editedItem.lot_size_tht > 0">
              <template v-slot:left>
                <BatchRunStatus v-model="editedItem.status" large></BatchRunStatus>
              </template>
              <template>
                <v-row dense no-gutters class="flex nowrap px-3">
                  <v-col class="d-flex justify-end mx-5"><span class="text-h6">{{$t('columns.qty')}}</span></v-col>
                  <v-col class="d-flex justify-end"><span class="text-h6">{{editedItem.lot_size_tht}}</span></v-col>
                </v-row>
              </template>
            </BaseCardListBlock>
          </v-row>
        </v-container>
        <BaseDetailTableFiltered
            ref="refBaseDetailFilteredTableImport"
            :item-list.sync="editedItem.batchrun_tasks"
            :height="componentHeight - 300"
            :height-toolbar="48"
            :dialog-width="windowWidth * 0.9"
            :columns="columnsBatchRunTask"
            edit-component-path="/PBatchRun/BatchRunTask/PBatchRunTaskItem"
            :left-cols="12"
            :show-select="false"
            :single-select="false"
            :edited-item="editedItem"
            :fetch-action="instance.fetchAction"
            row-statuses="row_status"
            row-filter-names="row_filters"
            :bar-statuses.sync="instance.editedItemCommon.bar_statuses"
            :bar-filters.sync="instance.editedItemCommon.bar_filters"
            :show-expand="false"
            :single-expand="false"
            item-key="uid"
            sort-by="order"
        >
          <template v-slot:top>
            {{ '' }}
          </template>
          <template v-slot:top.bar.action.middle="params">
            <BaseBtnActionGroup
                :bar-action-group="instance.editedItemCommon.bar_actions"
                :fetch-action="instance.fetchAction"
                :edited-item="editedItem"
                :selected-items="params.selectedItems"
                :loading="instance.commandLoading"
            >
            </BaseBtnActionGroup>
          </template>
          <template v-slot:top.bar.action.right="params">
            {{ '' }}
          </template>
          <template v-slot:top.bar.overlay="params">
            <v-overlay :value="instance.commandLoading">
              <v-progress-circular
                  indeterminate
                  size="32"
              ></v-progress-circular>
            </v-overlay>
          </template>
          <template v-slot:item.name="{ item }">
            <span class="text-h6">{{item.name}}</span>
          </template>
          <template v-slot:item.target_on="{ item }">
            <BaseFieldDate v-model="item.target_on"></BaseFieldDate>
          </template>
          <template v-slot:item.status="{ item }">
            <BatchRunTaskSelect v-model="item.status"></BatchRunTaskSelect>
          </template>
          <template v-slot:item.typ="{ item }">
            <BatchRunTaskName :value="item.typ"></BatchRunTaskName>
          </template>
          <template v-slot:item.ma="{ item }">
            <BaseSelectFromTable
                v-model="item.ma"
                store-name="UserTable"
                dto-model="UserListQueryDTO"
                item-text="human_user__user"
                multiple
                chips
                hide-details
            ></BaseSelectFromTable>
          </template>
        </BaseDetailTableFiltered>
      </v-sheet>
    </template>
  </BaseItem>
</template>

<script>
// import {mapGetters, mapActions} from 'vuex';
// import {mapFields} from 'vuex-map-fields';
import {v4 as uuidv4} from "uuid";
import ConfirmDialog from "@/components/Base/ConfirmDialog";
import BaseDetailTable from "@/components/Base/BaseDetailTable";
// import BaseItemProperty from "@/components/Base/BaseItemProperty";
import commonFunction from "@/commonFunction/commonFunction"
import BaseItem from "@/components/Base/BaseItem";
import BaseTable from "@/components/Base/BaseTable";
import BaseImageCard from "@/components/Base/BaseImageCard";
// import BomTable from "@/components/Component/Bom/BomTable";
import BaseFieldString from "@/components/Base/BaseFieldString";
import BaseFieldText from "@/components/Base/BaseFieldText";
import BaseFieldNumber from "@/components/Base/BaseFieldNumber";
import BaseFieldLink from "@/components/Base/BaseFieldLink";
import BaseSelectFromTable from "@/components/Base/BaseSelectFromTable";
import BaseFieldSelect from "@/components/Base/BaseFieldSelect";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import BaseDialogSelectFromTable from "@/components/Base/BaseDialogSelectFromTable";
// import CasePackageSupplyDefault from "@/components/Component/CasePackage/CasePackageSupplyDefault";
import BaseStatusIcon from "@/components/Base/BaseStatusIcon";
import BaseFieldDate from "@/components/Base/BaseFieldDate";
import BaseNotionLink from "@/components/Base/BaseNotionLink";
import PBatchRunEditDialog from "@/components/PBatchRun/BatchRun/PBatchRunEditDialog";
import BaseFieldWeek from "@/components/Base/BaseFieldWeek";
import BaseDetailTableFiltered from "@/components/Base/BaseDetailTableFiltered";
import BaseBtnActionGroup from "@/components/Base/BaseBtnActionGroup";
import BatchRunTaskSelect from "@/components/PBatchRun/BatchRunTask/BatchRunTaskStatusSelect";
import BatchRunStatus from "@/components/PBatchRun/BatchRun/BatchRunStatus";
import BatchRunTaskName from "@/components/PBatchRun/BatchRunTask/BatchRunTaskName";
import BaseCardListBlock from "@/components/Base/BaseCardListBlock";

export default {
  name: 'PBatchRunItem',
  props: {
    subtractHeight: {type: [Number], default: 240},
    height: {type: [Number], default: window.innerHeight},
    itemUid: {default: null},
    store_name: {type: [String], default: 'PBatchRunTable'},
    parentComponent: {type: [String], default: 'PBatchRunTable'},
    modalDialog: {type: [Boolean], default: false},
    dialog: {type: [Boolean], default: false},
    routeFullScreen: {type: [Object], default: null},
    readonly: {type: [Boolean], default: false},
    metadata: {default: null},
    showBom: {default: true},
  },

  components: {
    BaseFieldDate,
    BaseFieldString,
    ConfirmDialog,
    BaseItem,
    BaseDetailTable,
    BaseTable,
    BaseImageCard,
    // BomTable,
    BaseFieldText,
    BaseFieldNumber,
    BaseFieldLink,
    BaseSelectFromTable,
    BaseFieldSelect,
    BaseFieldCheck,
    BaseDialogSelectFromTable,
    // CasePackageSupplyDefault,
    BaseStatusIcon,
    BaseNotionLink,
    PBatchRunEditDialog,
    BaseFieldWeek,
    BaseDetailTableFiltered,
    BaseBtnActionGroup,
    BatchRunTaskSelect,
    BatchRunStatus,
    BatchRunTaskName,
    BaseCardListBlock,
  },

  computed: {},

  methods: {
    onSave(editedItem) {
      // console.log('ComponentOneItem onSave')
      this.$emit('save', editedItem)
      // this.$emit('change-search-term', editedItem.alias)
    },
    onResize(height) {
      // console.log('onResize', height)
      this.windowWidth = window.innerWidth
      this.componentHeight = height
    },
  },

  async mounted() {
  }
  ,

  data() {
    return {
      componentHeight: this.height,
      windowWidth: 900,
      week: null,
      columnsBatchRunTask: [
        // {text: '', value: 'edit', sortable: false, align: 'center', divider: true, width: 10},
        // {
        //   text: 'S',
        //   value: 'row_status',
        //   sortable: false,
        //   align: 'center',
        //   divider: false,
        //   width: 20,
        //   type: 'status'
        // },
        // {text: 'order', value: 'order', sortable: false, align: 'left', divider: true, width: 30},
        {text: this.$t('columns.name'), value: 'name', sortable: false, align: 'left', divider: true},
        {text: this.$t('columns.typ'), value: 'typ', sortable: false, align: 'center', divider: true, width: 100},
        {
          text: this.$t('columns.target_on'),
          value: 'target_on',
          sortable: false,
          align: 'center',
          divider: true,
          width: 100
        },
        {text: this.$t('columns.status'), value: 'status', sortable: false, align: 'center', divider: true, width: 150},
        {text: this.$t('columns.ma'), value: 'ma', sortable: false, align: 'center', divider: true, width: 300},
        {
          text: this.$t('columns.finished_on'),
          value: 'finished_on',
          sortable: false,
          align: 'center',
          divider: true,
          type: 'datetime',
          width: 120
        },
      ],
    }
  }
}
</script>

<style>
</style>

<i18n src="@/components/PBatchRun/locales.json">
</i18n>
